<template>
  <div class="project">
    <h2>This website</h2>
    <p>Stay tuned for more updates!</p>
  </div>
</template>

<script>
export default {
  
}
</script>

<style>
.project {
  margin: 20px auto;
  background: rgb(42, 47, 48);
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 1px 10px 2px #43494b80;
  width: 600px;
  height: 100px;
  background-color: #2a2f30;
  text-align: left;
}
h2 {
  color: #b16509;
  align-content: left;
  cursor: pointer;
}
p {
  
}
</style>